export default "__VITE_ASSET__wIRb3fEz__"